exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-grid-header {\r\n    display: inline-block;\r\n    font-weight: bold;\r\n}\r\n\r\n.mobile-grid-data {\r\n    display: inline-block;\r\n}\r\n", ""]);

// exports
